export default __webpack_public_path__ + "static/media/fMaltoBuza3.2b7a4c1e.png";